var exports = {
  "W": "slashCommandContainer__PhUTxr",
};

module.exports = exports;
